export default "__VITE_ASSET__BxOlcUdC__"